import { useMutation, useQueryClient } from "@tanstack/react-query";

import { removeToolAllowlistItem } from "./api";

// Аргументы DELETE: роль (для query+инвалидации) и имя инструмента.
export interface RemoveToolAllowlistItemArgs {
  readonly roleName: string;
  readonly toolName: string;
}

// DELETE разрешения по имени инструмента. На успех инвалидируем список пары —
// строка исчезнет из таблицы. Ключ включает role_name (тот же ключ, что у
// useToolAllowlist). Backend отдаёт 204 без тела.
export function useRemoveToolAllowlistItem(): ReturnType<
  typeof useMutation<void, Error, RemoveToolAllowlistItemArgs>
> {
  const queryClient = useQueryClient();
  return useMutation<void, Error, RemoveToolAllowlistItemArgs>({
    mutationFn: ({ roleName, toolName }) =>
      removeToolAllowlistItem(roleName, toolName),
    onSuccess: (_void, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ["toolAllowlist", variables.roleName],
      });
    },
  });
}
